import axios from './axios'

export default {
  async listing() {
    return await axios.get('/metric/listing', { unsecured: true })
  },
}
